export function isTimesheetApprovalDisabled(input: {
  busy: boolean;
  contractor: boolean;
  blockingAlertCount: number;
  approvalRowCount: number;
}) {
  return (
    input.busy ||
    (!input.contractor &&
      (input.blockingAlertCount > 0 || input.approvalRowCount === 0))
  );
}
